import React        from 'react';


class Page extends React.Component {


    render(){

        return (
            <section id={(this.props.id || 'page')} className={"page-content " + (this.props.classes || '')}>
                <h2>{this.props.title}</h2>
                {this.props.content}
            </section>
        )
    }
}


export default Page;